import { ClientProvider } from "@nju/data-access-sales-client";
import { Footer } from "@nju/feature-portal-footer";
import { ClientOrderInfoBox } from "@nju/feature-sales-client";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { RespectOrchestratorState } from "@nju/feature-sales-orchestrator";
import { MnpImpossiblePage } from "@nju/feature-sales-order";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function MnpImpossible() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <ClientSideOnly>
        <RespectOrchestratorState
          mode="mobile"
          state={["ITEM_SELECTION", "MNP"]}
        >
          <ClientProvider>
            <div>
              <ClientOrderInfoBox />
              <BlockContent>
                <MnpImpossiblePage />
              </BlockContent>
            </div>
          </ClientProvider>
        </RespectOrchestratorState>
      </ClientSideOnly>
      <Footer />
    </LayoutWrapper>
  );
}
